export enum MachineSoftwareUpdateStepType {
  UNKNOWN = 0,
  INSTALLING = 1, // Apt Install
  DOWNLOADING = 2, // Docker Pull
  CONTROLSYSTEM = 3 // Falcon Re-Program
}
